export default __webpack_public_path__ + "static/media/fea2.a9aafe29.jpg";